import {
  Box,
  Button,
  Card,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Link as RouteLink, useNavigate } from "react-router-dom";
import store, { RootState } from "../../../../store/store";
import CustomSeachInput from "../../../../shared/components/customSearchInput/customSearchInput";
import {
  PAGES_URL,
  ROWS_PER_PAGES,
  dashboardRfqStatuses,
  dateFilters,
} from "../../../../shared/constants/constants";
import PermissionsGate from "../../../../components/privateRoute/permissionsGate";
import { PLATFORM_PERMISSIONS } from "../../../../shared/models/abacConfig";
import DashboardRFQTable from "../../../../components/RFQ/DashboardRFQTable/DashboardRFQTable";
import { useDispatch, useSelector } from "react-redux";
import {
  setPagination,
  setFilters,
  setSelectedTab,
  setSelectedSort,
  setSelectedStatusList,
  setStoreSearchText,
  setDateSpanRedux,
} from "../../../../store/reducers/dashboard";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { getDates } from "../../../../shared/utils/utils";
import { getRateContractPagination } from "../../../../store/api/rateContract";
import DashboardRateContractTable from "../DashboardRateContract/dashboardRateContract";

const ListContractRate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storeStatusState = useSelector(
    (state: RootState) => state.dashboard.filters
  );
  const storePageState = useSelector(
    (state: RootState) => state.dashboard.currentPage
  );
  const storeRowsPerPageState = useSelector(
    (state: RootState) => state.dashboard.pageSize
  );
  const storeSortState = {
    type: useSelector((state: RootState) => state.dashboard.sortField),
    value: useSelector((state: RootState) => state.dashboard.sortOrder),
  };
  const storeTabState = useSelector(
    (state: RootState) => state.dashboard.selectedTab
  );
  const storeSearchTextState = useSelector(
    (state: RootState) => state.dashboard.searchText
  );
  const storeStatusListState = useSelector(
    (state: RootState) => state.dashboard.statusList
  );

  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [listData, setlistData] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [tab, setTab] = useState("RFQ");
  const [totalRows, setTotalRows] = useState(0);
  const [statusList, setStatusList] = useState(dashboardRfqStatuses);
  const [dateSpan, setDateSpan] = useState<any>({
    type: dateFilters["ALL"].value,
    startDate: dayjs(new Date()),
    endDate: dayjs(new Date()),
  });

  const storePartyState = useSelector((state: RootState) => state.party);
  const storeDateState = useSelector(
    (state: RootState) => state.dashboard.dateSpan
  );

  const [sort, setSort] = useState({
    type: "createdDate",
    value: "desc",
  });

  const [mount, setMount] = useState(false);

  useEffect(() => {
    if (mount) {
      //updating redux states for preserving page and sorts
      dispatch(setPagination({ currentPage: page, pageSize: rowsPerPage }));
      dispatch(setFilters(status));
      dispatch(setSelectedTab(tab));
      dispatch(
        setSelectedSort({
          sortField: sort.type,
          sortOrder: sort.value === "asc" ? "asc" : "desc",
        })
      );
      dispatch(setSelectedStatusList(statusList));
      dispatch(setStoreSearchText(searchText));
      dispatch(
        setDateSpanRedux({
          type: dateSpan.type,
          startDate: dateSpan.startDate.toString(),
          endDate: dateSpan.endDate.toString(),
        })
      );
      fetchRequests(searchText);
    }
  }, [
    page,
    rowsPerPage,
    status,
    tab,
    sort,
    statusList,
    searchText,
    dateSpan,
    storePartyState.currentOrg,
    mount,
  ]);

  useEffect(() => {
    // Set the initial local state from Redux values on mount
    if (storeTabState === "RC") {
      setStatus(storeStatusState || "");
      setPage(storePageState || 1);
      setRowsPerPage(storeRowsPerPageState || 10);
      setSort({
        type: storeSortState.type || "createdDate",
        value: storeSortState.value || "desc",
      });
      setTab(storeTabState || "RC");
      setStatusList(storeStatusListState || dashboardRfqStatuses);
      setSearchText(storeSearchTextState || "");
      setDateSpan({
        type: storeDateState.type || dateFilters["ALL"].value,
        startDate: dayjs(storeDateState.startDate) || dayjs(new Date()),
        endDate: dayjs(storeDateState.endDate) || dayjs(new Date()),
      });
    }
    setMount(true);
  }, []);

  const handleSearch = (searchString: string) => {
    setSearchText(searchString);
    fetchRequests(searchString);
  };

  const fetchRequests = (searchString: any) => {
    // let inputSearchText = searchText;
    // if (searchString && searchString != "") {
    //   inputSearchText = searchString;
    // }
    // const { startDate, endDate } = getDates(dateSpan);

    const reqObj: any = {
      //   status: status === "REQUEST_ALL" ? "ALL" : status,
      //   text: inputSearchText,
      page: page,
      pageSize: rowsPerPage,
      //   sort: sort.type + ":" + sort.value,
      org: storePartyState.currentOrg,
      //   startDate,
      //   endDate,
    };
    // if (status === dashboardRfqStatuses["Bidding Open"]) {
    //   reqObj.status = dashboardRfqStatuses.Approved;
    //   reqObj["closeAfterDate"] = new Date();
    // }
    store
      .dispatch(getRateContractPagination(reqObj))
      .unwrap()
      .then((resp: any) => {
        setlistData(resp.data);
        const totalRecords = resp.data?.totalRecords
          ? resp.data?.totalRecords
          : 0;
        setTotalRows(totalRecords);
        const pageCount = Math.ceil(totalRecords / rowsPerPage);
        setPageCount(pageCount);
      })
      .catch(() => {});
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDateType = (event: SelectChangeEvent) => {
    setPage(1);
    setDateSpan({
      ...dateSpan,
      type: event.target.value,
    });
  };

  const handleChange = (event: SelectChangeEvent) => {
    setPage(1);
    // console.log("status is ", event);
    setStatus(event.target.value);
  };

  const handleSort = (column: string) => {
    setPage(1);

    if (sort.type === column) {
      setSort({
        type: column,
        value: sort.value === "asc" ? "desc" : "asc",
      });
    } else {
      setSort({
        type: column,
        value: "asc",
      });
    }
  };

  return (
    <Box
      flex={1}
      display={"flex"}
      flexDirection={"column"}
      padding={4}
      sx={{ backgroundColor: "#fff" }}
    >
      <Box
        sx={{ mb: 2 }}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        // className="headerBox"
      >
        <Typography fontSize={24} fontWeight={600}>
          Rate Contract List
        </Typography>
        <Stack direction={"row"}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#22438C",
              borderRadius: 0,
              "&:hover": { backgroundColor: "#22438C", opacity: "80%" },
            }}
            onClick={() =>
              navigate(
                `${PAGES_URL.ORDERMGR}/${PAGES_URL.RATE_CONTRACT_CREATE}`
              )
            }
          >
            <Typography textTransform={"none"}>Create Rate Contract</Typography>
          </Button>
        </Stack>
      </Box>
      <Box flex={1}>
        <Box className="DashboardContainer">
          <Card>
            <Box display={"flex"} flexDirection={"column"} height={"100%"}>
              {/* <Box
                sx={{ width: "100%", height: "75px" }}
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                borderBottom=(theme) => `solid 1px ${theme.palette.secondary.main}`,
              >
                <Box
                  display={"flex"}
                  alignItems={"baseline"}
                  p={2}
                  width={"100%"}
                  justifyContent={"space-between"}
                >
                  <Box display={"flex"} alignItems={"baseline"}>
                    <Box className="search">
                      <CustomSeachInput
                        screenName="ListRFQs"
                        handleSearch={handleSearch}
                        text={searchText}
                      />
                    </Box>
                    <Box
                      sx={{
                        minWidth: "159px",
                        height: "38px",
                        display: "flex",
                        alignItems: "baseline",
                        backgroundColor: "rgba(246, 246, 246, 1) !important",
                        border: (theme) => `solid 1px ${theme.palette.secondary.main}`,
                        marginRight: "26px",
                        paddingLeft: "10px",
                      }}
                      className="sort"
                    >
                      <InputLabel
                        id="demo-multiple-checkbox-label"
                        sx={{ display: "contents" }}
                      >
                        Sort by:
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        fullWidth
                        size="small"
                        id="SortField"
                        sx={{
                          ".MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          paddingRight: "0px",
                        }}
                        value={status}
                        onChange={handleChange}
                      >
                        {Object.keys(statusList).map((key) => (
                          <MenuItem
                            className="sortOptions"
                            value={statusList[key]}
                            key={key}
                          >
                            {key}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {
                      <Box
                        sx={{
                          display: "flex",
                          // backgroundColor: 'rgba(246, 246, 246, 1) !important',
                          border: (theme) => `solid 1px ${theme.palette.secondary.main}`,
                          px: 2,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        className="sort"
                      >
                        <InputLabel
                          id="demo-multiple-checkbox-label"
                          sx={{ display: "contents" }}
                        >
                          Select Date Range:
                        </InputLabel>
                        <Select
                          labelId="demo-multiple-checkbox-label"
                          fullWidth
                          size="small"
                          id="SortField"
                          sx={{
                            ".MuiOutlinedInput-notchedOutline": {
                              border: "none",
                            },
                          }}
                          value={dateFilters[dateSpan?.type]?.value}
                          onChange={handleChangeDateType}
                        >
                          {Object.keys(dateFilters).map((key) => (
                            <MenuItem
                              className="sortOptions"
                              value={dateFilters[key]?.value}
                            >
                              {dateFilters[key]?.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </Box>
                    }
                  </Box>

                  <PermissionsGate
                    permissions={[PLATFORM_PERMISSIONS.REQUEST_CREATE]}
                  >
                    <Button
                      className="dashboardCreateRO"
                      variant="contained"
                      sx={{
                        mr: 1,
                      }}
                      onClick={() => {
                        navigate(
                          `${PAGES_URL.ORDERMGR}/${PAGES_URL.CREATE_RFQ}`
                        );
                      }}
                    >
                      <Typography>Create RFQ</Typography>
                    </Button>
                  </PermissionsGate>
                </Box>
              </Box>
              {dateSpan?.type === dateFilters["CUSTOM"]?.value && (
                <Stack direction={"row"} p={2} spacing={2}>
                  <Box width={"15%"} className="sort">
                    <Typography fontSize={14}>Start Date</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{
                          textField: {
                            placeholder: "Choose the start range",
                            size: "small",
                            fullWidth: true,
                            error: false,
                          },
                        }}
                        // minDate={minimumDateLimit}
                        format="DD-MM-YYYY"
                        value={dateSpan.startDate}
                        onChange={(date: any) => {
                          if (date > dateSpan?.endDate) {
                            setDateSpan({
                              ...dateSpan,
                              startDate: date,
                              endDate: date,
                            });
                          } else {
                            setDateSpan({ ...dateSpan, startDate: date });
                          }
                        }}
                        sx={
                          {
                            // backgroundColor: '#f6f6f6',
                          }
                        }
                      />
                    </LocalizationProvider>
                  </Box>
                  <Box width={"15%"} className="sort">
                    <Typography fontSize={14}>End Date</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{
                          textField: {
                            placeholder: "Choose the start range",
                            size: "small",
                            fullWidth: true,
                            error: false,
                          },
                        }}
                        minDate={dateSpan?.startDate}
                        format="DD-MM-YYYY"
                        value={dateSpan.endDate}
                        onChange={(date: any) => {
                          setDateSpan({ ...dateSpan, endDate: date });
                        }}
                        sx={
                          {
                            // backgroundColor: '#f6f6f6',
                          }
                        }
                      />
                      <FormHelperText error={false}>
                            {"End Date should be greater than start date"}
                        </FormHelperText>
                    </LocalizationProvider>
                  </Box>
                </Stack>
              )} */}
              <Box flex={1} marginTop={"40px"}>
                <DashboardRateContractTable
                  sort={sort}
                  onSort={handleSort}
                  rateContractListData={listData}
                ></DashboardRateContractTable>
              </Box>
              <Box
                minHeight={"79px"}
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <span className="recordsInfo">
                  Showing data{" "}
                  {totalRows ? (page - 1) * rowsPerPage + 1 : totalRows} to{" "}
                  {(page - 1) * rowsPerPage + rowsPerPage < totalRows
                    ? (page - 1) * rowsPerPage + rowsPerPage
                    : totalRows}{" "}
                  of {totalRows} entries
                </span>
                <Stack
                  direction={"row"}
                  spacing={1}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Pagination
                    className="pagination"
                    count={pageCount}
                    page={page}
                    onChange={handleChangePage}
                  />
                  <Typography>Result Per Page</Typography>
                  <Select
                    labelId="row_count"
                    size="small"
                    id="RowCountField"
                    sx={{
                      ".MuiOutlinedInput-notchedOutline": { border: "none" },
                      paddingRight: "0px",
                    }}
                    value={rowsPerPage}
                    onChange={(e) => setRowsPerPage(Number(e.target.value))}
                  >
                    {ROWS_PER_PAGES.map((key) => (
                      <MenuItem className="sortOptions" key={key} value={key}>
                        {key}
                      </MenuItem>
                    ))}
                  </Select>
                </Stack>
              </Box>
            </Box>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

export default ListContractRate;
